import request from '@/utils/request'

// 绑定支付宝
export function bindZFB(data) {
    return request({
        url: `/agent/personal/set-transfer-account`,
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/bindZFB.js